import { render, staticRenderFns } from "./SwiperOne.vue?vue&type=template&id=a0a1ad6a&scoped=true&"
import script from "./SwiperOne.vue?vue&type=script&lang=js&"
export * from "./SwiperOne.vue?vue&type=script&lang=js&"
import style0 from "./SwiperOne.vue?vue&type=style&index=0&id=a0a1ad6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a1ad6a",
  null
  
)

export default component.exports